/**
 * Referral/dealer attribution storage.
 *
 * Landing links `/r/:code` (and `?ref=`/`?dealer=` query params on any page)
 * persist the code here; the checkout page pre-fills from it and clears it
 * after a successful order so the attribution is consumed exactly once.
 */

const REFERRAL_KEY = 'fyt_referral_code';
const DEALER_KEY = 'fyt_dealer_code';

export function captureAttributionFromUrl(): void {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref');
  const dealer = params.get('dealer');
  if (ref) localStorage.setItem(REFERRAL_KEY, ref.trim().toUpperCase());
  if (dealer) localStorage.setItem(DEALER_KEY, dealer.trim().toUpperCase());
}

export function getStoredReferralCode(): string {
  return localStorage.getItem(REFERRAL_KEY) || '';
}

export function getStoredDealerCode(): string {
  return localStorage.getItem(DEALER_KEY) || '';
}

export function setStoredReferralCode(code: string): void {
  const normalized = code.trim().toUpperCase();
  if (normalized) localStorage.setItem(REFERRAL_KEY, normalized);
  else localStorage.removeItem(REFERRAL_KEY);
}

export function setStoredDealerCode(code: string): void {
  const normalized = code.trim().toUpperCase();
  if (normalized) localStorage.setItem(DEALER_KEY, normalized);
  else localStorage.removeItem(DEALER_KEY);
}

export function clearAttribution(): void {
  localStorage.removeItem(REFERRAL_KEY);
  localStorage.removeItem(DEALER_KEY);
}
